// dependencies
import React from "react";
import { List, Map } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components

// actions
import { init, initializeGraph, setActiveGraph } from "./actions";

// selectors
import { getActiveGraph, getGraphsList, getActiveGraphData } from "./selectors";

// css
import css from "./Graphs";

class GraphPage extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
		initializeGraph: PropTypes.func.isRequired,
		setActiveGraph: PropTypes.func.isRequired,
		environment: PropTypes.string.isRequired,
		activeGraph: PropTypes.instanceOf(Map).isRequired,
		activeGraphData: PropTypes.instanceOf(Map).isRequired,
		graphsList: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	constructor(props) {
		super(props);

		this.graphsContainer = React.createRef();
	}

	componentDidMount = () => {
		this.props.init(this.graphsContainer.current.offsetWidth);
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.environment !== this.props.environment) {
			this.props.initializeGraph();
		}
	};

	handleClick = (graphName) => {
		this.props.setActiveGraph(graphName);
	};

	render = () => {
		const { activeGraph, graphsList, activeGraphData } = this.props;
		const activeGraphName = activeGraph.get("name");
		const graphIsSelected = activeGraph.size > 0;

		return (
			<div ref={this.graphsContainer} className={css.GraphsPage}>
				<div className={css.graphsList}>
					{graphsList.map((graph) => (
						<div
							key={graph.get("name")}
							onClick={() => this.handleClick(graph.get("url"))}
							className={`${css.graphsListItem} ${
								graph.get("name") === activeGraphName ? css.isActive : ""
							}`}
						>
							<div className={css.innerWrapper}>{graph.get("label")}</div>
						</div>
					))}
				</div>

				<div className={css.graphContainer}>
					<div className={css.graphWrapper}>
						{graphIsSelected
							? activeGraph.get("component")({
									data: activeGraphData,
									graphWidth: 600,
								})
							: null}
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	graphsList: getGraphsList(state),
	activeGraph: getActiveGraph(state),
	activeGraphData: getActiveGraphData(state),
});

const mapDispatchToProps = (dispatch) => ({
	initializeGraph: () => dispatch(initializeGraph()),
	init: (graphWidth) => dispatch(init(graphWidth)),
	setActiveGraph: (graphName) => dispatch(setActiveGraph(graphName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphPage);
